var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('az-call-to-action',{attrs:{"slot":"actions","id":"botaoSalvar","css-class":"text-uppercase b-0"},on:{"click":function($event){return _vm.$emit('salvar')}},slot:"actions"},[_vm._v(" Salvar ")])}
var staticRenderFns = []

export { render, staticRenderFns }